import { render, staticRenderFns } from "./PosOrderDetail.vue?vue&type=template&id=3d9c1486&scoped=true&"
import script from "./PosOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PosOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./PosOrderDetail.vue?vue&type=style&index=0&id=3d9c1486&scoped=true&lang=css&"
import style1 from "./PosOrderDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c1486",
  null
  
)

export default component.exports